
































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'

import ItemList from '@/components/organisms/ItemList.vue'
import { Page } from '@/models/page'

/**
 * 本コンポーネントは今ではオートロードする場合の商品リスト表示でしか利用されない。
 * また、本コンポーネントの責務は画面内外の状態に応じたDOMの切り替えなので、organisms/auto-loadへの移動を検討したい。
 * その際には現在 <item-list> を表示している箇所を slot で注入できるようにするなどの修正が必要となる。
 *
 * @see https://github.com/my-color/growthpalette-front/pull/7845#pullrequestreview-1827821145
 */
@Component({
  components: {
    ItemList,
  },
})
export default class ItemListContainer extends Vue {
  $refs: {
    'item-list-content': ItemList,
  }

  @Prop({ default: 'div' })
  tag: string

  @Prop({ required: true })
  page: Page<any>

  @Prop({ required: true })
  isInsideViewport: boolean

  @Prop({ required: true })
  maximumLoadedPageNumber: number

  // 200pxは画像が読み込まれて高さが確定するまでの初期値
  // 1行分が300pxほどだが、初期値を上回った場合のみemptyDivHeightを更新するようにしている (updateHeight) ため、
  // ずっと初期値のままにならないように少し小さめに設定している。
  // 初期値がないと複数ページが同時にviewportに入り、一気に読み込まれてしまう
  readonly minimumHeight: number = 200
  emptyDivHeight: number = this.minimumHeight

  /**
   * 何も描画すべきでないパターンかを判定する。
   *
   * 全商品数が8の倍数の場合などにpage.listが空のページが最後にロードされるが、
   * この場合はContainerの表示は不要。
   * また、表示中のアイテムとinfinite-loadingのスピナー間にも空白などは不要なため、
   * 現在読み込み済みの最後のページ以降もContainerの表示は不要。
   */
  get shouldHideContainer(): boolean {
    return (
      (this.page.loaded && this.page.list.length === 0) ||
      //
      (this.page.number > this.maximumLoadedPageNumber)
    )
  }

  /**
   * 画面内→画面外へ変化した場合に空divの高さを更新する
   *
   * 商品リスト要素の高さは画像のロードが完了するたびに変更されるため、
   * 商品画像が1件読み込まれるたびに逐次変化する可能性がある。
   *
   * emptyDivHeightは空divが表示されるタイミング（画面内→画面外に変化したタイミング）
   * でのみ適切に更新されれば良いので、isInsideViewportの変更をトリガーに行うことにした。
   *
   * @see https://github.com/my-color/growthpalette-front/pull/7831#discussion_r1446352192
   *
   */
  @Watch('isInsideViewport')
  updateHeight(): void {
    if (this.$refs['item-list-content'] && !this.isInsideViewport) {
      this.emptyDivHeight = Math.max(this.$refs['item-list-content'].$el.clientHeight, this.minimumHeight)
    }
  }
}
